import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';

export default function PropertyManagementSection({ isMobile }) {
    return (
        <div className="bg-white py-5">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} lg={6} className="mb-4 mb-lg-0">
                        <img
                            src={`${process.env.PUBLIC_URL}/svg/undraw_cabin_7fei.svg`}
                            alt="Property Management"
                            className="img-fluid"
                            style={{ maxHeight: '400px', width: '100%', objectFit: 'contain' }}
                        />
                    </Col>
                    <Col xs={12} lg={6}>
                        <h2 className="fw-bold mb-4">Property Management</h2>
                        <h4 className="fw-light mb-4">
                            We offer 24/7 standard reliable property management in Chicagoland and have reliable vendors.
                        </h4>
                        <p className="lead text-muted mb-4">
                            Trust us to handle the day-to-day operations of your property with professionalism and care. From tenant relations to maintenance, we've got you covered.
                        </p>
                        <Button variant="primary" size="lg" href="/property-management">Learn More</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
